import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dropdown,
  Grid,
  Menu,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';

import { fetchM } from '../../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../../actions/flash';
import PictureList from '../../../../components/PictureList';
import NavBar from '../../../../components/NavBar';
import AddPicture from '../../../modals/AddPicture';
import ViewLarge from '../../../modals/ViewLarge';
import RemovePicture from '../../../modals/RemovePicture';
import LayoutTitle from '../LayoutTitle';
import { routes } from '../navigations';
import { namespaces, TRANSLATION_FILES } from '../../../../constants/translation';

class Pictures extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    pictureToken: PropTypes.string,
    id: PropTypes.string,
    unitLayoutID: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Pictures.getPropsToState(props);
    this.state = {
      ...state,
      showConfirm: false,
      showLarge: false,
      selectedPicture: null,
      showAddPicture: false,
      pictures: [],
    };
    this.pictureList = null;
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Pictures.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleRefetch() {
    this.pictureList.getWrappedInstance().handleRefetch();
  }
  addPicture(type) {
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/pictures/${this.state.selectedPicture.id}/`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.pictureToken,
      },
      body: JSON.stringify({ type }),
    }))
      .then(() => {
        this.pictureModal.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: 'Add Picture Success', message: 'Picture successfully added to unit layout' }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  deletePicture() {
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/pictures/${this.state.selectedPicture.id}/`, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.pictureToken,
      },
    }))
      .then(() => {
        this.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: 'Delete Success', message: 'Picture successfully deleted' }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  handleCancelRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
      selectedPicture: null,
    });
  }
  handleRemove = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
    }, () => {
      this.setState({
        showConfirm: true,
      });
    });
  }
  handleConfirmRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
    }, () => {
      this.deletePicture();
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
    });
  }
  handleViewLarge = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
      showLarge: true,
    });
  }
  handleShowAddPicture = (e) => {
    e.preventDefault();
    this.setState({
      showAddPicture: true,
    });
  }
  handleCloseAddPicture = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleRefetch();
    this.setState({
      showAddPicture: false,
    });
  }
  handleAddPicture = (e, selectedPicture, pictureType) => {
    e.preventDefault();
    this.setState({
      selectedPicture,
    }, () => {
      this.addPicture(pictureType);
    });
  }
  handleUpload = body => ({
    url: `/projects/${this.props.id}/unit_layouts/${this.props.unitLayoutID}/pictures/`,
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        // Let browser decide Content-Type
        'X-Csrf-Token': this.props.pictureToken,
      },
      body,
    },
  })
  handleCheck = (data) => {
    if (data.unitLayouts && data.unitLayouts.length > 0) {
      return data.unitLayouts.some(p => p.projectUnitLayoutID === this.props.unitLayoutID);
    }
    return false;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleGetPictures = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedPicture } = this.state;
    const index = pictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: pictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedPicture } = this.state;
    if (selectedPicture) {
      const index = pictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  render() {
    const { t } = this.props;
    const { pathname } = this.props.location;
    const { store } = this.context;
    const links = routes(this.props.id, this.props.unitLayoutID, true);
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                active={pathname === link.value}
                onClick={() => store.dispatch(replace(link.value))}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleShowAddPicture}
                disabled={this.state.loading}
                primary
                icon="add"
                content={t('Add', { ns: TRANSLATION_FILES.translation })}
              />
            </Menu.Item>
          }
        />
        <LayoutTitle data={this.props.data} />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <AddPicture
                type="unit_layout"
                ref={(ref) => { this.pictureModal = ref; }}
                open={this.state.showAddPicture}
                onClose={this.handleCloseAddPicture}
                onConfirm={this.handleAddPicture}
                onUpload={this.handleUpload}
                onCheck={this.handleCheck}
              />
              <ViewLarge
                open={this.state.showLarge}
                onClose={this.handleCloseLarge}
                picture={this.state.selectedPicture}
                onSlide={this.handleSlidePicture}
                disabledLeft={!this.checkDisabled('left')}
                disabledRight={!this.checkDisabled('right')}
                slideshow={this.state.showLarge}
              />
              <RemovePicture
                open={this.state.showConfirm}
                onClose={this.handleCancelRemove}
                onConfirm={this.handleConfirmRemove}
                picture={this.state.selectedPicture}
                data={this.props.data}
              />
              <PictureList
                ref={(ref) => { this.pictureList = ref; }}
                toggleable
                projectID={this.props.id}
                unitLayoutID={this.props.unitLayoutID}
                onChange={this.handleGetPictures}
                onViewLarge={this.handleViewLarge}
                onRemove={this.handleRemove}
                buttonNode={({ isMobile, view, loading, picture }) => (
                  view === 'list' ? (
                    <Button
                      size="tiny"
                      compact
                      negative
                      icon="remove"
                      content={isMobile ? null : 'Remove'}
                      disabled={loading}
                      onClick={e => this.handleRemove(e, picture)}
                    />
                  ) : null
                )}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(...namespaces)(Pictures);



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/Pictures/List.jsx